import { Box, Button, Divider, Grid, Paper, TextField } from '@mui/material';
import { INiveisEmergencia } from '../../../services/api/action-plan/Pae';
import { useEffect, useState } from 'react';
import { Add, Remove } from '@mui/icons-material';

interface EmergencyLevelsProps {
    smDown: boolean,
    value: INiveisEmergencia[] | undefined,
    onChange: (data: INiveisEmergencia[]) => void
}

export const EmergencyLevels = ({onChange, smDown, value}: EmergencyLevelsProps) => {
    
    const [dataSteps, setDataSteps] = useState<INiveisEmergencia[]>([]);

    useEffect(() => {
        if (value) {
            setDataSteps(value);
        }
    }, [smDown]);
  
    const handleAdd = () => {
        const newItem: INiveisEmergencia = {};
        setDataSteps(prevDataSteps => {
          const newDataSteps = [...prevDataSteps, newItem];
          onChange(newDataSteps);
          return newDataSteps;
        });
    };
  
    const handleRemove = () => {
        setDataSteps(prevDataSteps => {
          const newDataSteps = prevDataSteps.slice(0, -1);
          onChange(newDataSteps);
          return newDataSteps;
        });
    };
  
    const handleChange = (index: number, field: keyof INiveisEmergencia, value: string) => {
        setDataSteps(prevDataSteps => {
          const newDataSteps = prevDataSteps.map((item, i) => i === index ? { ...item, [field]: value } : item);
          onChange(newDataSteps);
          return newDataSteps;
        });
    };    
  
    return (
      <Box>
        <Box display={'flex'} justifyContent={'center'} flexDirection={'row'} gap={2}>
          <Button
            startIcon={<Add />}
            sx={{ borderRadius: '35px' }}
            onClick={handleAdd}
            variant='contained'
          >
            Adicionar
          </Button>
          <Button
            startIcon={<Remove />}
            sx={{ borderRadius: '35px' }}
            onClick={handleRemove}
            variant='contained'
          >
            Remover
          </Button>
        </Box>
  
        <Divider sx={{ margin: '15px' }} />
  
        {dataSteps.map((item, index) => (
          <Box component={Paper} sx={{ borderRadius: '25px' }} padding={1} variant='outlined' key={index} margin={3}>
            <Grid container spacing={2} padding={2}>
              <Grid item xs={smDown ? 12 : 6}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  label='Nível'
                  name='nivel'
                  value={item.nivel || ''}
                  onChange={(e) => handleChange(index, 'nivel', e.target.value)}
                />
              </Grid>
              <Grid item xs={smDown ? 12 : 6}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  label='Definição'
                  value={item.definicao || ''}
                  onChange={(e) => handleChange(index, 'definicao', e.target.value)}
                />
              </Grid>
            </Grid>
          </Box>
        ))}
      </Box>
    );
  };